import React from 'react';
import { Row, Col, Card, Button, Typography } from 'antd';
import { AndroidFilled,AppleFilled, DownloadOutlined, WindowsFilled } from '@ant-design/icons';
import Seo from './Seo';
import { LastUpdated } from './LastUpdated';
import './DownloadPage.css';

const { Title, Text } = Typography;

const DownloadPage: React.FC = () => {
  return (
    <div className="download-page">
        <Seo
            title="下载软件｜妙视力App下载（Android / iOS / Windows）"
            description="下载妙视力视觉训练App：支持Android设备、iOS设备和Windows（Win10及以上）设备，立即下载开始视觉功能训练。"
            canonical="https://miaoshili.com/download/"
        />
        <div className="download-page-bg">
            {/* 主要内容区域 */}
            <div className="main-content">
                <div className="logo-section">
                    <div className="logo-image"><img src="/msl_app_logo.webp" alt="妙视力App图标" width={"100%"}/> </div>
                    <Title level={1} className="app-title">妙视力</Title>
                </div>

                <Text className="download-text">立即下载</Text>

                <Row gutter={[30, 30]} justify="center">
                    <Col xs={24} sm={12} md={8}>
                        {/* Android版本 */}
                        <Card className="download-card android-card" bordered={false}>
                            <div className="card-content">
                                <div className="card-icon">
                                    <div className="icon-background android-icon">
                                        <AndroidFilled className="card-icon-inner" />
                                    </div>
                                </div>
                                <Title level={3} className="card-title">Android版本</Title>
                                <Text className="card-description">支持所有Android设备</Text>
                                <Button type="primary" className="download-button" icon={<DownloadOutlined />} href="https://train.miaoshili.com/download/app-release.apk" target="_blank">
                                    下载Android版
                                </Button>
                            </div>
                        </Card>
                    </Col>

                    <Col xs={24} sm={12} md={8}>
                        {/* Windows版本 */}
                        <Card className="download-card windows-card" bordered={false}>
                            <div className="card-content">
                                <div className="card-icon">
                                    <div className="icon-background windows-icon">
                                        <WindowsFilled className="card-icon-inner" />
                                    </div>
                                </div>
                                <Title level={3} className="card-title">Windows版本</Title>
                                <Text className="card-description">支持Win10及以上设备</Text>
                                <Button type="primary" className="download-button" icon={<DownloadOutlined />} href="https://train.miaoshili.com/download/nice-vision-install.exe" target="_blank">
                                    Windows版
                                </Button>
                            </div>
                        </Card>
                    </Col>

                    <Col xs={24} sm={12} md={8}>
                        {/* iOS版本 */}
                        <Card className="download-card ios-card" bordered={false}>
                            <div className="card-content">
                                <div className="card-icon">
                                    <div className="icon-background ios-icon">
                                        <AppleFilled className="card-icon-inner" /> {/* 临时使用Android图标，实际应使用iOS图标 */}
                                    </div>
                                </div>
                                <Title level={3} className="card-title">iOS版本</Title>
                                <Text className="card-description">支持所有iOS设备</Text>
                                <Button type="primary" className="download-button" icon={<DownloadOutlined />} href="https://apps.apple.com/cn/app/id6752773415" target="_blank">
                                    下载iOS版
                                </Button>
                            </div>
                        </Card>
                    </Col>
                </Row>
                <LastUpdated/>
            </div>
        </div>
    </div>
  );
};

export default DownloadPage;